<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'additionalCost-masterdata-page',
};

</script>
